// @flow

// a little function to help us with reordering the result
// eslint-disable-next-line import/prefer-default-export, @typescript-eslint/no-explicit-any
export const reorder = (list: Array<any>, start: number, end: number) => {
  const result = Array.from(list)
  const [ removed ] = result.splice(start, 1)
  result.splice(end, 0, removed)
  return result
}
